import { LDFlags } from '../../../constants/flags';
import { useExternalUserPayoffRequestQuery } from '../../../gql/generated/graphql';
import { useFlag } from '../../../hooks';
import ClosingDashboard from '../dashboardStates/ClosingDashboard';
import MainDashboard from '../dashboardStates/MainDashboard';
import SoftCloseDashboard from '../dashboardStates/SoftCloseDashboard';
import StructuringDashboard from '../dashboardStates/StructuringDashboard';
import { DealWithFarthestState } from '../utils';
import StepperDashboard from './stepper/StepperDashboard';
import PostSigningStepperDashboard from './stepper/postSigningStepper/PostSigningStepperDashboard';

type DashboardContentProps = {
  deal: DealWithFarthestState;
  isDealSoftClosing: boolean;
  isDealClosing: boolean;
  isDealStructuring: boolean;
  showDashboardStepper: boolean;
  showPostSigningStepper: boolean;
};

const DashboardContent = ({
  deal,
  isDealSoftClosing,
  isDealClosing,
  isDealStructuring,
  showDashboardStepper,
  showPostSigningStepper,
}: DashboardContentProps) => {
  const payoffIntelligenceEnabled = useFlag(LDFlags.PAYOFF_INTELLIGENCE_ENABLED);
  const payoffIntelligencePanelEnabled = useFlag(LDFlags.COM_PAYOFF_INTELLIGENCE_DASHBOARD_PANEL);
  const { data: payoffRequestData, loading: payoffRequestLoading } =
    useExternalUserPayoffRequestQuery({
      variables: {
        dealId: deal?.id,
      },
      skip:
        !deal?.id ||
        !payoffIntelligenceEnabled ||
        !payoffIntelligencePanelEnabled ||
        showPostSigningStepper,
    });

  const showPayoffIntelligenceVariation =
    payoffIntelligenceEnabled &&
    payoffIntelligencePanelEnabled &&
    !!payoffRequestData?.externalUserPayoffRequest &&
    !payoffRequestLoading;

  if (showDashboardStepper) {
    return <StepperDashboard deal={deal} />;
  }

  if (showPostSigningStepper) {
    return <PostSigningStepperDashboard deal={deal} />;
  }

  if (isDealClosing) {
    return (
      <ClosingDashboard
        deal={deal}
        showPayoffIntelligenceVariation={showPayoffIntelligenceVariation}
      />
    );
  }

  if (isDealStructuring) {
    return (
      <StructuringDashboard
        deal={deal}
        showPayoffIntelligenceVariation={showPayoffIntelligenceVariation}
      />
    );
  }

  if (isDealSoftClosing) {
    return <SoftCloseDashboard deal={deal} />;
  }

  return <MainDashboard deal={deal} />;
};

export default DashboardContent;
